<script setup>
const props = defineProps({
  icon: { type: String, required: true },
});
</script>

<template>
  <iconify-icon :icon="props.icon" />
</template>

